import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./lib/auth";
import { Spinner } from "./components/ui";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import UserDetail from "./pages/UserDetail";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Organisations from "./pages/Organisations";
import Config from "./pages/Config";
import Signing from "./pages/Signing";
import FeatureFlags from "./pages/FeatureFlags";
import RateLimits from "./pages/RateLimits";
import AuthSessions from "./pages/AuthSessions";
import Admins from "./pages/Admins";
import AuditLog from "./pages/AuditLog";

function RequireAuth({ children }: { children: React.ReactElement }) {
  const { admin, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Spinner className="min-h-screen" />;
  if (!admin) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/:email" element={<UserDetail />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/organisations" element={<Organisations />} />
        <Route path="/config" element={<Config />} />
        <Route path="/signing" element={<Signing />} />
        <Route path="/feature-flags" element={<FeatureFlags />} />
        <Route path="/rate-limits" element={<RateLimits />} />
        <Route path="/auth-sessions" element={<AuthSessions />} />
        <Route path="/admins" element={<Admins />} />
        <Route path="/audit-log" element={<AuditLog />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
